import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bc321a7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4bc321a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc321a7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,Button: require('/app/components/Button.vue').default,FaqRefonte: require('/app/components/FaqRefonte.vue').default,NetworkForm: require('/app/components/NetworkForm.vue').default,FooterV2: require('/app/components/FooterV2.vue').default,LazyCalendly: require('/app/components/LazyCalendly.vue').default})
